/* WARNING: This file is auto-generated . Do not edit manually. */

import { AuthCredentialStateEnum } from '../models/AuthCredentialStateEnum';
import { NichandleNicAutorenewInfos } from '../models/NichandleNicAutorenewInfos';
import { NichandleAuthenticationRoleEnum } from '../models/NichandleAuthenticationRoleEnum';
import { MePaymentMeanPaypal } from '../models/MePaymentMeanPaypal';
import { NichandleDomainTaskProgressBar } from '../models/NichandleDomainTaskProgressBar';
import { BillingPayment } from '../models/BillingPayment';
import { MePaymentTransaction } from '../models/MePaymentTransaction';
import { TelephonyMailDomain2Service } from '../models/TelephonyMailDomain2Service';
import { MeConsentCampaign } from '../models/MeConsentCampaign';
import { MePaymentMeanBankAccountChallengeCreation } from '../models/MePaymentMeanBankAccountChallengeCreation';
import { BillingCreditBalance } from '../models/BillingCreditBalance';
import { BillingMovement } from '../models/BillingMovement';
import { MePaymentMeanCreditCard } from '../models/MePaymentMeanCreditCard';
import { XdslSetting } from '../models/XdslSetting';
import { NichandleUser } from '../models/NichandleUser';
import { MeIncidentServiceMigration } from '../models/MeIncidentServiceMigration';
import { BillingOrderRegisteredPaymentMean } from '../models/BillingOrderRegisteredPaymentMean';
import { DedicatedServerPartitionRaidEnum } from '../models/DedicatedServerPartitionRaidEnum';
import { DomainTask } from '../models/DomainTask';
import { MeBillingGroupService } from '../models/MeBillingGroupService';
import { BillingBill } from '../models/BillingBill';
import { NichandleDomainTaskArgument } from '../models/NichandleDomainTaskArgument';
import { TelephonyDefaultIpRestriction } from '../models/TelephonyDefaultIpRestriction';
import { NichandleIpxe } from '../models/NichandleIpxe';
import { NichandleSubAccount } from '../models/NichandleSubAccount';
import { NichandleEmailChangeTask } from '../models/NichandleEmailChangeTask';
import { BillingOvhAccount } from '../models/BillingOvhAccount';
import { BillingOrderRetractionReasonEnum } from '../models/BillingOrderRetractionReasonEnum';
import { NichandleAccessRestrictionU2FAccount } from '../models/NichandleAccessRestrictionU2FAccount';
import { MePaymentMeanBankAccount } from '../models/MePaymentMeanBankAccount';
import { MeSupportLevelLevel } from '../models/MeSupportLevelLevel';
import { NichandleAccessRestrictionIpRestrictionRuleEnum } from '../models/NichandleAccessRestrictionIpRestrictionRuleEnum';
import { MeIncidentOrder } from '../models/MeIncidentOrder';
import { BillingBillDetail } from '../models/BillingBillDetail';
import { NichandleDeveloperModeRestriction } from '../models/NichandleDeveloperModeRestriction';
import { NichandleAccessRestrictionU2FRegisterChallenge } from '../models/NichandleAccessRestrictionU2FRegisterChallenge';
import { NichandleSshKey } from '../models/NichandleSshKey';
import { MeConsumptionTransaction } from '../models/MeConsumptionTransaction';
import { DedicatedInstallationTemplateTemplatePartitioningSchemes } from '../models/DedicatedInstallationTemplateTemplatePartitioningSchemes';
import { DomainOperationStatusEnum } from '../models/DomainOperationStatusEnum';
import { MeAbuseAbuse } from '../models/MeAbuseAbuse';
import { NichandleAccessRestrictionTOTPSecret } from '../models/NichandleAccessRestrictionTOTPSecret';
import { BillingOrderConsumptionDetails } from '../models/BillingOrderConsumptionDetails';
import { MePaymentMethodDetails } from '../models/MePaymentMethodDetails';
import { MePaymentMeanBankAccountStateEnum } from '../models/MePaymentMeanBankAccountStateEnum';
import { BillingReverseBill } from '../models/BillingReverseBill';
import { NichandleAccessRestrictionU2FSignChallenge } from '../models/NichandleAccessRestrictionU2FSignChallenge';
import { BillingOrderAssociatedObject } from '../models/BillingOrderAssociatedObject';
import { MePaymentMeanBankAccountValidation } from '../models/MePaymentMeanBankAccountValidation';
import { TelephonyProtocolEnum } from '../models/TelephonyProtocolEnum';
import { DedicatedTemplateOsHardwareRaidEnum } from '../models/DedicatedTemplateOsHardwareRaidEnum';
import { NichandleNichandle } from '../models/NichandleNichandle';
import { NichandleAccessRestrictionSmsAccount } from '../models/NichandleAccessRestrictionSmsAccount';
import { BillingOrderOrderStatusEnum } from '../models/BillingOrderOrderStatusEnum';
import { ContactFieldInformation } from '../models/ContactFieldInformation';
import { MeGeolocationContinentCountryLocation } from '../models/MeGeolocationContinentCountryLocation';
import { MeCreditBalanceMovement } from '../models/MeCreditBalanceMovement';
import { AgreementsContract } from '../models/AgreementsContract';
import { ApiLog } from '../models/ApiLog';
import { MePaymentMeanPaypalValidation } from '../models/MePaymentMeanPaypalValidation';
import { DedicatedInstallationTemplateHardwareRaid } from '../models/DedicatedInstallationTemplateHardwareRaid';
import { NichandleAuthenticationGroup } from '../models/NichandleAuthenticationGroup';
import { DedicatedInstallationTemplateTemplatePartitions } from '../models/DedicatedInstallationTemplateTemplatePartitions';
import { BillingCategoryEnum } from '../models/BillingCategoryEnum';
import { MeCreditBalance } from '../models/MeCreditBalance';
import { NichandleAccessRestrictionSOTPValidate } from '../models/NichandleAccessRestrictionSOTPValidate';
import { MeBillingPurchaseOrderCreation } from '../models/MeBillingPurchaseOrderCreation';
import { BillingOrderPayWithPaymentMethod } from '../models/BillingOrderPayWithPaymentMethod';
import { MePaymentTransactionStatusEnum } from '../models/MePaymentTransactionStatusEnum';
import { NichandleIpRestriction } from '../models/NichandleIpRestriction';
import { AgreementsContractAgreement } from '../models/AgreementsContractAgreement';
import { TelephonySettings } from '../models/TelephonySettings';
import { MeConsentConsent } from '../models/MeConsentConsent';
import { MeMigration } from '../models/MeMigration';
import { MeTagTag } from '../models/MeTagTag';
import { DebtDebt } from '../models/DebtDebt';
import { NichandleDocumentDocument } from '../models/NichandleDocumentDocument';
import { BillingOrderDetail } from '../models/BillingOrderDetail';
import { DebtOperation } from '../models/DebtOperation';
import { NichandleChangeContactTaskStateEnum } from '../models/NichandleChangeContactTaskStateEnum';
import { BillingArchiveTypeEnum } from '../models/BillingArchiveTypeEnum';
import { NichandleAccessRestrictionSOTPSecret } from '../models/NichandleAccessRestrictionSOTPSecret';
import { DedicatedTemplateOsFileSystemEnum } from '../models/DedicatedTemplateOsFileSystemEnum';
import { MeMigrationContract } from '../models/MeMigrationContract';
import { BillingWithdrawalDetail } from '../models/BillingWithdrawalDetail';
import { RecommendationsProductRangesEnum } from '../models/RecommendationsProductRangesEnum';
import { AuthApiApplication } from '../models/AuthApiApplication';
import { MePaymentMeanCreditCardChallengeCreation } from '../models/MePaymentMeanCreditCardChallengeCreation';
import { NichandleAccessRestrictionSmsCode } from '../models/NichandleAccessRestrictionSmsCode';
import { MeBillingGroupBillingGroup } from '../models/MeBillingGroupBillingGroup';
import { MePaymentMethodFinalize } from '../models/MePaymentMethodFinalize';
import { MePaymentAvailablePaymentMethod } from '../models/MePaymentAvailablePaymentMethod';
import { IpCampusEnum } from '../models/IpCampusEnum';
import { InsightAccess } from '../models/InsightAccess';
import { DebtBalance } from '../models/DebtBalance';
import { NichandleChangeEmailTaskStateEnum } from '../models/NichandleChangeEmailTaskStateEnum';
import { MeCreditCodeRedeem } from '../models/MeCreditCodeRedeem';
import { MeIncidentMigrateServices } from '../models/MeIncidentMigrateServices';
import { NichandleAccessRestrictionSOTPAccount } from '../models/NichandleAccessRestrictionSOTPAccount';
import { BillingOrder } from '../models/BillingOrder';
import { DedicatedTemplateOsLanguageEnum } from '../models/DedicatedTemplateOsLanguageEnum';
import { AuditLog } from '../models/AuditLog';
import { ConsumptionConsumptionExportFormatsEnum } from '../models/ConsumptionConsumptionExportFormatsEnum';
import { NichandleEmailNotification } from '../models/NichandleEmailNotification';
import { BillingOrderFollowUp } from '../models/BillingOrderFollowUp';
import { BillingItemDetail } from '../models/BillingItemDetail';
import { BillingOrderPaymentMeans } from '../models/BillingOrderPaymentMeans';
import { BillingReversableBillDetail } from '../models/BillingReversableBillDetail';
import { AuthApiCredential } from '../models/AuthApiCredential';
import { NichandleAuthenticationProvider } from '../models/NichandleAuthenticationProvider';
import { BillingAutomaticPaymentMean } from '../models/BillingAutomaticPaymentMean';
import { MeBillingGroupServiceCreate } from '../models/MeBillingGroupServiceCreate';
import { BillingOrderPaymentMethods } from '../models/BillingOrderPaymentMethods';
import { NichandleSubAccountConsumerKey } from '../models/NichandleSubAccountConsumerKey';
import { DedicatedInstallationTemplateTemplates } from '../models/DedicatedInstallationTemplateTemplates';
import { NichandleCountryEnum } from '../models/NichandleCountryEnum';
import { BillingDepositDetail } from '../models/BillingDepositDetail';
import { BillingDeposit } from '../models/BillingDeposit';
import { MePaymentMeanPaypalChallengeCreation } from '../models/MePaymentMeanPaypalChallengeCreation';
import { BillingWithdrawal } from '../models/BillingWithdrawal';
import { DedicatedTemplatePartitionTypeEnum } from '../models/DedicatedTemplatePartitionTypeEnum';
import { NichandleIpRestrictionDefaultRule } from '../models/NichandleIpRestrictionDefaultRule';
import { MeBillingPurchaseOrderPurchaseOrder } from '../models/MeBillingPurchaseOrderPurchaseOrder';
import { MePaymentMethodValidation } from '../models/MePaymentMethodValidation';
import { BillingRefundDetail } from '../models/BillingRefundDetail';
import { NichandleVipStatus } from '../models/NichandleVipStatus';
import { NichandleVoucherStatus } from '../models/NichandleVoucherStatus';
import { NichandleAccessRestrictionTOTPAccount } from '../models/NichandleAccessRestrictionTOTPAccount';
import { NichandleAuthenticationProviderExtensions } from '../models/NichandleAuthenticationProviderExtensions';
import { MePaymentPaymentMethod } from '../models/MePaymentPaymentMethod';
import { MePaymentMeanBankAccountCreation } from '../models/MePaymentMeanBankAccountCreation';
import { MePaymentMethodCreation } from '../models/MePaymentMethodCreation';
import { DomainOperationFunctionEnum } from '../models/DomainOperationFunctionEnum';
import { MePaymentMeanCreditCardCreation } from '../models/MePaymentMeanCreditCardCreation';
import { NichandleIpv4Org } from '../models/NichandleIpv4Org';
import { NichandleAccessRestrictionSmsSecret } from '../models/NichandleAccessRestrictionSmsSecret';
import { MePaymentMeanPaypalCreation } from '../models/MePaymentMeanPaypalCreation';
import { MeAgreementsContractAgreement } from '../models/MeAgreementsContractAgreement';
import { MeBillingPurchaseOrderUpdate } from '../models/MeBillingPurchaseOrderUpdate';
import { MeTagCreation } from '../models/MeTagCreation';
import { NichandleContactChangeTask } from '../models/NichandleContactChangeTask';
import { MeCreditBalanceTypeEnum } from '../models/MeCreditBalanceTypeEnum';
import { NichandleOvhCompanyEnum } from '../models/NichandleOvhCompanyEnum';
import { MePartnerLevelLevel } from '../models/MePartnerLevelLevel';
import { NichandleSubscription } from '../models/NichandleSubscription';
import { MePaymentMeanCreditCardValidation } from '../models/MePaymentMeanCreditCardValidation';
import { MeContactContact } from '../models/MeContactContact';
import { MePaymentMethodStatusEnum } from '../models/MePaymentMethodStatusEnum';
import { AgreementsAgreementStateEnum } from '../models/AgreementsAgreementStateEnum';
import { BillingSlaOperationService } from '../models/BillingSlaOperationService';
import { BillingFidelityAccount } from '../models/BillingFidelityAccount';
import { BillingRefund } from '../models/BillingRefund';
import { DebtEntryAssociatedObject } from '../models/DebtEntryAssociatedObject';
import { BillingReusablePaymentMeanEnum } from '../models/BillingReusablePaymentMeanEnum';
import { MePaymentMethodChallenge } from '../models/MePaymentMethodChallenge';
import { RecommendationsRecommendations } from '../models/RecommendationsRecommendations';
import { MePaymentMeanDeferred } from '../models/MePaymentMeanDeferred';
import { BillingFidelityMovement } from '../models/BillingFidelityMovement';
import { MeTagAvailableTag } from '../models/MeTagAvailableTag';
import { NichandleIpRegistryEnum } from '../models/NichandleIpRegistryEnum';
import { BillingSlaOperation } from '../models/BillingSlaOperation';
import OVHBase from '../ovh';

class MeHandler {
  ovh: OVHBase;

  constructor(ovh: OVHBase) {
    this.ovh = ovh;
  }

  /** Get details about your nichandle */
  get = (): Promise<NichandleNichandle> => {
    return this.ovh.request('GET', '/me');
  };

  /** Update details of your nichandle */
  update = (body: NichandleNichandle): Promise<void> => {
    return this.ovh.request('PUT', '/me', body);
  };

  /** Retrieve abuse cases list */
  getAbuse = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/abuse');
  };

  /** Check specific abuse case */
  checkAbuseById = (id: string): Promise<MeAbuseAbuse> => {
    return this.ovh.request('GET', `/me/abuse/${id}`);
  };

  /** Delete this Two-Factor */
  deleteAccessRestrictionBackupCode = (): Promise<void> => {
    return this.ovh.request('DELETE', '/me/accessRestriction/backupCode');
  };

  /** Get this object properties */
  getAccessRestrictionBackupCode = (): Promise<NichandleAccessRestrictionSOTPAccount> => {
    return this.ovh.request('GET', '/me/accessRestriction/backupCode');
  };

  /** Add a SOTP access restriction */
  addAccessRestrictionBackupCode = (): Promise<NichandleAccessRestrictionSOTPSecret> => {
    return this.ovh.request('POST', '/me/accessRestriction/backupCode');
  };

  /** Disable this SOTP account */
  disableAccessRestrictionBackupCode = (body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', '/me/accessRestriction/backupCode/disable', body);
  };

  /** Enable this SOTP account */
  enableAccessRestrictionBackupCode = (body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', '/me/accessRestriction/backupCode/enable', body);
  };

  /** Validate your SOTP account */
  validateAccessRestrictionBackupCode = (body: {
    code: string;
  }): Promise<NichandleAccessRestrictionSOTPValidate> => {
    return this.ovh.request('POST', '/me/accessRestriction/backupCode/validate', body);
  };

  /** Get this object properties */
  getAccessRestrictionDeveloperMode = (): Promise<NichandleDeveloperModeRestriction> => {
    return this.ovh.request('GET', '/me/accessRestriction/developerMode');
  };

  /** Alter this object properties */
  updateAccessRestrictionDeveloperMode = (
    body: NichandleDeveloperModeRestriction
  ): Promise<void> => {
    return this.ovh.request('PUT', '/me/accessRestriction/developerMode', body);
  };

  /** List of IP restrictions */
  listAccessRestrictionIp = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/accessRestriction/ip');
  };

  /** Add an IP access restriction */
  addAccessRestrictionIp = (body: {
    ip: string;
    rule: NichandleAccessRestrictionIpRestrictionRuleEnum;
    warning: boolean;
  }): Promise<void> => {
    return this.ovh.request('POST', '/me/accessRestriction/ip', body);
  };

  /** Delete this restriction rule */
  deleteAccessRestrictionIpById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/accessRestriction/ip/${id}`);
  };

  /** Get this object properties */
  getAccessRestrictionIpById = (id: number): Promise<NichandleIpRestriction> => {
    return this.ovh.request('GET', `/me/accessRestriction/ip/${id}`);
  };

  /** Alter this object properties */
  updateAccessRestrictionIpById = (id: number, body: NichandleIpRestriction): Promise<void> => {
    return this.ovh.request('PUT', `/me/accessRestriction/ip/${id}`, body);
  };

  /** Get this object properties */
  getAccessRestrictionIpDefaultRule = (): Promise<NichandleIpRestrictionDefaultRule> => {
    return this.ovh.request('GET', '/me/accessRestriction/ipDefaultRule');
  };

  /** Alter this object properties */
  updateAccessRestrictionIpDefaultRule = (
    body: NichandleIpRestrictionDefaultRule
  ): Promise<void> => {
    return this.ovh.request('PUT', '/me/accessRestriction/ipDefaultRule', body);
  };

  /** List of Sms accounts */
  listAccessRestrictionSms = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/accessRestriction/sms');
  };

  /** Add a SMS access restriction */
  addAccessRestrictionSms = (body: {
    phone: string;
  }): Promise<NichandleAccessRestrictionSmsSecret> => {
    return this.ovh.request('POST', '/me/accessRestriction/sms', body);
  };

  /** Delete this Two-Factor */
  deleteAccessRestrictionSmsById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/accessRestriction/sms/${id}`);
  };

  /** Get this object properties */
  getAccessRestrictionSmsById = (id: number): Promise<NichandleAccessRestrictionSmsAccount> => {
    return this.ovh.request('GET', `/me/accessRestriction/sms/${id}`);
  };

  /** Alter this object properties */
  updateAccessRestrictionSmsById = (
    id: number,
    body: NichandleAccessRestrictionSmsAccount
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/accessRestriction/sms/${id}`, body);
  };

  /** Disable this SMS account */
  disableAccessRestrictionSmsById = (id: number, body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/sms/${id}/disable`, body);
  };

  /** Enable this SMS account */
  enableAccessRestrictionSmsById = (id: number, body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/sms/${id}/enable`, body);
  };

  /** Send a SMS to this account */
  sendAccessRestrictionSmsCodeById = (id: number): Promise<NichandleAccessRestrictionSmsCode> => {
    return this.ovh.request('POST', `/me/accessRestriction/sms/${id}/sendCode`);
  };

  /** Validate your SMS account */
  validateAccessRestrictionSmsById = (id: number, body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/sms/${id}/validate`, body);
  };

  /** List of TOTP accounts */
  listAccessRestrictionTotp = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/accessRestriction/totp');
  };

  /** Add a TOTP access restriction */
  addAccessRestrictionTotp = (): Promise<NichandleAccessRestrictionTOTPSecret> => {
    return this.ovh.request('POST', '/me/accessRestriction/totp');
  };

  /** Delete this Two-Factor */
  deleteAccessRestrictionTotpById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/accessRestriction/totp/${id}`);
  };

  /** Get this object properties */
  getAccessRestrictionTotpById = (id: number): Promise<NichandleAccessRestrictionTOTPAccount> => {
    return this.ovh.request('GET', `/me/accessRestriction/totp/${id}`);
  };

  /** Alter this object properties */
  updateAccessRestrictionTotpById = (
    id: number,
    body: NichandleAccessRestrictionTOTPAccount
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/accessRestriction/totp/${id}`, body);
  };

  /** Disable this TOTP account */
  disableAccessRestrictionTotpById = (id: number, body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/totp/${id}/disable`, body);
  };

  /** Enable this TOTP account */
  enableAccessRestrictionTotpById = (id: number, body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/totp/${id}/enable`, body);
  };

  /** Validate your TOTP account */
  validateAccessRestrictionTotpById = (id: number, body: { code: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/totp/${id}/validate`, body);
  };

  /** List of U2F accounts */
  listAccessRestrictionU2f = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/accessRestriction/u2f');
  };

  /** Add a U2F access restriction */
  addAccessRestrictionU2f = (): Promise<NichandleAccessRestrictionU2FRegisterChallenge> => {
    return this.ovh.request('POST', '/me/accessRestriction/u2f');
  };

  /** Delete this Two-Factor */
  deleteAccessRestrictionU2fById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/accessRestriction/u2f/${id}`);
  };

  /** Get this object properties */
  getAccessRestrictionU2fById = (id: number): Promise<NichandleAccessRestrictionU2FAccount> => {
    return this.ovh.request('GET', `/me/accessRestriction/u2f/${id}`);
  };

  /** Alter this object properties */
  updateAccessRestrictionU2fById = (
    id: number,
    body: NichandleAccessRestrictionU2FAccount
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/accessRestriction/u2f/${id}`, body);
  };

  /** Get an U2F Challenge */
  postAccessRestrictionU2fChallengeById = (
    id: number
  ): Promise<NichandleAccessRestrictionU2FSignChallenge> => {
    return this.ovh.request('POST', `/me/accessRestriction/u2f/${id}/challenge`);
  };

  /** Disable this U2F account */
  disableAccessRestrictionU2fById = (
    id: number,
    body: { clientData: string; signatureData: string }
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/u2f/${id}/disable`, body);
  };

  /** Enable this U2F account */
  enableAccessRestrictionU2fById = (
    id: number,
    body: { clientData: string; signatureData: string }
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/u2f/${id}/enable`, body);
  };

  /** Validate your U2F account */
  validateAccessRestrictionU2fById = (
    id: number,
    body: { clientData: string; registrationData: string }
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/accessRestriction/u2f/${id}/validate`, body);
  };

  /** List of contracts signed between you and OVH */
  listAgreements = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/agreements');
  };

  /** Get this object properties */
  getAgreementsById = (id: number): Promise<AgreementsContractAgreement> => {
    return this.ovh.request('GET', `/me/agreements/${id}`);
  };

  /** Accept this contract */
  postAgreementsAcceptById = (id: number): Promise<string> => {
    return this.ovh.request('POST', `/me/agreements/${id}/accept`);
  };

  /** Get this object properties */
  getAgreementsContractById = (id: number): Promise<AgreementsContract> => {
    return this.ovh.request('GET', `/me/agreements/${id}/contract`);
  };

  /** Retrieve all applications */
  getApiApplication = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/api/application');
  };

  /** Delete an application. It will revoke all credential belonging to this application */
  deleteApiApplicationByApplicationId = (applicationId: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/api/application/${applicationId}`);
  };

  /** Retrieve information about an application */
  getApiApplicationByApplicationId = (applicationId: number): Promise<AuthApiApplication> => {
    return this.ovh.request('GET', `/me/api/application/${applicationId}`);
  };

  /** Retrieve all credentials */
  getApiCredential = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/api/credential');
  };

  /** Delete a credential */
  deleteApiCredentialByCredentialId = (credentialId: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/api/credential/${credentialId}`);
  };

  /** Retrieve information about a credential */
  getApiCredentialByCredentialId = (credentialId: number): Promise<AuthApiCredential> => {
    return this.ovh.request('GET', `/me/api/credential/${credentialId}`);
  };

  /** Edit a credential */
  updateApiCredentialByCredentialId = (
    credentialId: number,
    body: AuthApiCredential
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/api/credential/${credentialId}`, body);
  };

  /** Get associated application */
  getApiCredentialApplicationByCredentialId = (
    credentialId: number
  ): Promise<AuthApiApplication> => {
    return this.ovh.request('GET', `/me/api/credential/${credentialId}/application`);
  };

  /** List of Api calls done with your account */
  listApiLogsSelf = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/api/logs/self');
  };

  /** Get this object properties */
  getApiLogsSelfByLogId = (logId: number): Promise<ApiLog> => {
    return this.ovh.request('GET', `/me/api/logs/self/${logId}`);
  };

  /** List of Api calls done on services you have access to */
  listApiLogsServices = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/api/logs/services');
  };

  /** Get this object properties */
  getApiLogsServicesByLogId = (logId: number): Promise<ApiLog> => {
    return this.ovh.request('GET', `/me/api/logs/services/${logId}`);
  };

  /** Get this object properties */
  getAutorenew = (): Promise<NichandleNicAutorenewInfos> => {
    return this.ovh.request('GET', '/me/autorenew');
  };

  /** Activate auto renew for this nic */
  postAutorenew = (body: { renewDay: number }): Promise<void> => {
    return this.ovh.request('POST', '/me/autorenew', body);
  };

  /** Alter this object properties */
  updateAutorenew = (body: NichandleNicAutorenewInfos): Promise<void> => {
    return this.ovh.request('PUT', '/me/autorenew', body);
  };

  /** List available payment methods in this Nic's country */
  listAvailableAutomaticPaymentMeans = (): Promise<BillingAutomaticPaymentMean> => {
    return this.ovh.request('GET', '/me/availableAutomaticPaymentMeans');
  };

  /** List of all the bills the logged account has */
  listBill = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/bill');
  };

  /** Exports a bundle of invoices */
  exportBill = (body: {
    archiveType: BillingArchiveTypeEnum;
    endDate?: Date;
    ids?: string[];
    startDate?: Date;
  }): Promise<void> => {
    return this.ovh.request('POST', '/me/bill/export', body);
  };

  /** Get this object properties */
  getBillByBillId = (billId: string): Promise<BillingBill> => {
    return this.ovh.request('GET', `/me/bill/${billId}`);
  };

  /** Get this object properties */
  getBillDebtByBillId = (billId: string): Promise<DebtDebt> => {
    return this.ovh.request('GET', `/me/bill/${billId}/debt`);
  };

  /** All operations related to these debts */
  getBillDebtOperationByBillId = (billId: string): Promise<number[]> => {
    return this.ovh.request('GET', `/me/bill/${billId}/debt/operation`);
  };

  /** Get this object properties */
  getBillDebtOperationByBillIdAndOperationId = (
    billId: string,
    operationId: number
  ): Promise<DebtOperation> => {
    return this.ovh.request('GET', `/me/bill/${billId}/debt/operation/${operationId}`);
  };

  /** Return main data about the object related to this debt operation */
  getBillDebtOperationAssociatedObjectByBillIdAndOperationId = (
    billId: string,
    operationId: number
  ): Promise<DebtEntryAssociatedObject> => {
    return this.ovh.request(
      'GET',
      `/me/bill/${billId}/debt/operation/${operationId}/associatedObject`
    );
  };

  /** Create an order in order to pay this order's debt */
  createBillDebtPayByBillId = (billId: string): Promise<BillingOrder> => {
    return this.ovh.request('POST', `/me/bill/${billId}/debt/pay`);
  };

  /** Give access to all entries of the bill */
  getBillDetailsByBillId = (billId: string): Promise<string[]> => {
    return this.ovh.request('GET', `/me/bill/${billId}/details`);
  };

  /** Get this object properties */
  getBillDetailsByBillIdAndBillDetailId = (
    billDetailId: string,
    billId: string
  ): Promise<BillingBillDetail> => {
    return this.ovh.request('GET', `/me/bill/${billId}/details/${billDetailId}`);
  };

  /** Get this object properties */
  getBillPaymentByBillId = (billId: string): Promise<BillingPayment> => {
    return this.ovh.request('GET', `/me/bill/${billId}/payment`);
  };

  /** Retrieve all billing groups */
  getBillingGroup = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/billing/group');
  };

  /** Create a new billing group */
  createBillingGroup = (body: MeBillingGroupBillingGroup): Promise<MeBillingGroupBillingGroup> => {
    return this.ovh.request('POST', '/me/billing/group', body);
  };

  /** Delete a billing group */
  deleteBillingGroupByGroupId = (groupId: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/billing/group/${groupId}`);
  };

  /** Retrieve information about a billing group */
  getBillingGroupByGroupId = (groupId: number): Promise<MeBillingGroupBillingGroup> => {
    return this.ovh.request('GET', `/me/billing/group/${groupId}`);
  };

  /** Edit billing group */
  updateBillingGroupByGroupId = (
    groupId: number,
    body: MeBillingGroupBillingGroup
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/billing/group/${groupId}`, body);
  };

  /** Retrieve billing group service ID list */
  getBillingGroupServiceByGroupId = (groupId: number): Promise<number[]> => {
    return this.ovh.request('GET', `/me/billing/group/${groupId}/service`);
  };

  /** Associate a service to a billing group */
  postBillingGroupServiceByGroupId = (
    groupId: number,
    body: MeBillingGroupServiceCreate
  ): Promise<MeBillingGroupService> => {
    return this.ovh.request('POST', `/me/billing/group/${groupId}/service`, body);
  };

  /** Unlink a service from a billing group */
  deleteBillingGroupServiceByGroupIdAndServiceId = (
    groupId: number,
    serviceId: number
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/me/billing/group/${groupId}/service/${serviceId}`);
  };

  /** Retrieve information about a billing group service */
  getBillingGroupServiceByGroupIdAndServiceId = (
    groupId: number,
    serviceId: number
  ): Promise<MeBillingGroupService> => {
    return this.ovh.request('GET', `/me/billing/group/${groupId}/service/${serviceId}`);
  };

  /** Send invoices through postal mail */
  sendBillingInvoicesByPostalMail = (): Promise<boolean> => {
    return this.ovh.request('GET', '/me/billing/invoicesByPostalMail');
  };

  /** Enable or disable invoices by postal mail */
  enableBillingInvoicesByPostalMail = (body: { enable: boolean }): Promise<void> => {
    return this.ovh.request('POST', '/me/billing/invoicesByPostalMail', body);
  };

  /** Retrieve all purchase orders */
  getBillingPurchaseOrder = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/billing/purchaseOrder');
  };

  /** Create a purchase order */
  createBillingPurchaseOrder = (
    body: MeBillingPurchaseOrderCreation
  ): Promise<MeBillingPurchaseOrderPurchaseOrder> => {
    return this.ovh.request('POST', '/me/billing/purchaseOrder', body);
  };

  /** Delete a purchase order */
  deleteBillingPurchaseOrderById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/billing/purchaseOrder/${id}`);
  };

  /** Retrieve information about a purchase order */
  getBillingPurchaseOrderById = (id: number): Promise<MeBillingPurchaseOrderPurchaseOrder> => {
    return this.ovh.request('GET', `/me/billing/purchaseOrder/${id}`);
  };

  /** Update a purchase order */
  updateBillingPurchaseOrderById = (
    id: number,
    body: MeBillingPurchaseOrderUpdate
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/billing/purchaseOrder/${id}`, body);
  };

  /** Get your Bring your own IP token */
  getBringYourOwnIpToken = (): Promise<string> => {
    return this.ovh.request('GET', '/me/bringYourOwnIp/token');
  };

  /** Get all certificates of the account */
  getCertificates = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/certificates');
  };

  /** Initiate an email change procedure */
  postChangeEmail = (body: { newEmail: string }): Promise<NichandleEmailChangeTask> => {
    return this.ovh.request('POST', '/me/changeEmail', body);
  };

  /** Initiate a password change procedure */
  postChangePassword = (): Promise<void> => {
    return this.ovh.request('POST', '/me/changePassword');
  };

  /** List all consent campaign available */
  listConsent = (): Promise<MeConsentCampaign[]> => {
    return this.ovh.request('GET', '/me/consent');
  };

  /** Retrieve information about a consent campaign */
  getConsentByCampaignName = (campaignName: string): Promise<MeConsentCampaign> => {
    return this.ovh.request('GET', `/me/consent/${campaignName}`);
  };

  /** Get decision value for a consent campaign */
  getConsentDecisionByCampaignName = (campaignName: string): Promise<MeConsentConsent> => {
    return this.ovh.request('GET', `/me/consent/${campaignName}/decision`);
  };

  /** Update decision of a consent campaign */
  updateConsentDecisionByCampaignName = (
    campaignName: string,
    body: { value: boolean }
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/consent/${campaignName}/decision`, body);
  };

  /** Get on-going consumptions for all services */
  getConsumptionUsageCurrent = (): Promise<MeConsumptionTransaction[]> => {
    return this.ovh.request('GET', '/me/consumption/usage/current');
  };

  /** Get forecasted consumptions for all services */
  getConsumptionUsageForecast = (): Promise<MeConsumptionTransaction[]> => {
    return this.ovh.request('GET', '/me/consumption/usage/forecast');
  };

  /** Get list of transactions between two dates */
  getConsumptionUsageHistory = (): Promise<MeConsumptionTransaction[]> => {
    return this.ovh.request('GET', '/me/consumption/usage/history');
  };

  /** Retrieve every contact your created */
  getContact = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/contact');
  };

  /** Create a new contact */
  createContact = (body: MeContactContact): Promise<MeContactContact> => {
    return this.ovh.request('POST', '/me/contact', body);
  };

  /** Retrieve information about a contact */
  getContactByContactId = (contactId: number): Promise<MeContactContact> => {
    return this.ovh.request('GET', `/me/contact/${contactId}`);
  };

  /** Update an existing contact */
  updateContactByContactId = (
    contactId: number,
    body: MeContactContact
  ): Promise<MeContactContact> => {
    return this.ovh.request('PUT', `/me/contact/${contactId}`, body);
  };

  /** Display mandatory/read-only informations of a contact */
  getContactFieldsByContactId = (contactId: number): Promise<ContactFieldInformation[]> => {
    return this.ovh.request('GET', `/me/contact/${contactId}/fields`);
  };

  /** Retrieve all credit balances */
  getCreditBalance = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/credit/balance');
  };

  /** Retrieve a credit balance */
  getCreditBalanceByBalanceName = (balanceName: string): Promise<MeCreditBalance> => {
    return this.ovh.request('GET', `/me/credit/balance/${balanceName}`);
  };

  /** Retrieve movements for a specific balance */
  getCreditBalanceMovementByBalanceName = (balanceName: string): Promise<number[]> => {
    return this.ovh.request('GET', `/me/credit/balance/${balanceName}/movement`);
  };

  /** Retrieve a specific movement for a credit balance */
  getCreditBalanceMovementByBalanceNameAndMovementId = (
    balanceName: string,
    movementId: number
  ): Promise<MeCreditBalanceMovement> => {
    return this.ovh.request('GET', `/me/credit/balance/${balanceName}/movement/${movementId}`);
  };

  /** Validate a code to generate associated credit movement */
  validateCreditCode = (body: MeCreditCodeRedeem): Promise<MeCreditBalanceMovement> => {
    return this.ovh.request('POST', '/me/credit/code', body);
  };

  /** Get this object properties */
  getDebtAccount = (): Promise<DebtBalance> => {
    return this.ovh.request('GET', '/me/debtAccount');
  };

  /** All debts related to your account */
  getDebtAccountDebt = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/debtAccount/debt');
  };

  /** Get this object properties */
  getDebtAccountDebtByDebtId = (debtId: number): Promise<DebtDebt> => {
    return this.ovh.request('GET', `/me/debtAccount/debt/${debtId}`);
  };

  /** All operations related to these debts */
  getDebtAccountDebtOperationByDebtId = (debtId: number): Promise<number[]> => {
    return this.ovh.request('GET', `/me/debtAccount/debt/${debtId}/operation`);
  };

  /** Get this object properties */
  getDebtAccountDebtOperationByDebtIdAndOperationId = (
    debtId: number,
    operationId: number
  ): Promise<DebtOperation> => {
    return this.ovh.request('GET', `/me/debtAccount/debt/${debtId}/operation/${operationId}`);
  };

  /** Return main data about the object related to this debt operation */
  getDebtAccountDebtOperationAssociatedObjectByDebtIdAndOperationId = (
    debtId: number,
    operationId: number
  ): Promise<DebtEntryAssociatedObject> => {
    return this.ovh.request(
      'GET',
      `/me/debtAccount/debt/${debtId}/operation/${operationId}/associatedObject`
    );
  };

  /** Create an order in order to pay this order's debt */
  createDebtAccountDebtPayByDebtId = (debtId: number): Promise<BillingOrder> => {
    return this.ovh.request('POST', `/me/debtAccount/debt/${debtId}/pay`);
  };

  /** Create an order in order to pay all your due debts */
  createDebtAccountPay = (): Promise<BillingOrder> => {
    return this.ovh.request('POST', '/me/debtAccount/pay');
  };

  /** List of all the deposits made to your prepaid account or debt account */
  listDeposit = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/deposit');
  };

  /** Get this object properties */
  getDepositByDepositId = (depositId: string): Promise<BillingDeposit> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}`);
  };

  /** Give access to all entries of this deposit */
  getDepositDetailsByDepositId = (depositId: string): Promise<string[]> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/details`);
  };

  /** Get this object properties */
  getDepositDetailsByDepositIdAndDepositDetailId = (
    depositDetailId: string,
    depositId: string
  ): Promise<BillingDepositDetail> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/details/${depositDetailId}`);
  };

  /** Get invoices paid by this deposit */
  getDepositPaidBillsByDepositId = (depositId: string): Promise<string[]> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/paidBills`);
  };

  /** Get this object properties */
  getDepositPaidBillsByDepositIdAndBillId = (
    billId: string,
    depositId: string
  ): Promise<BillingBill> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/paidBills/${billId}`);
  };

  /** Get this object properties */
  getDepositPaidBillsDebtByDepositIdAndBillId = (
    billId: string,
    depositId: string
  ): Promise<DebtDebt> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/paidBills/${billId}/debt`);
  };

  /** All operations related to these debts */
  getDepositPaidBillsDebtOperationByDepositIdAndBillId = (
    billId: string,
    depositId: string
  ): Promise<number[]> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/paidBills/${billId}/debt/operation`);
  };

  /** Get this object properties */
  getDepositPaidBillsDebtOperationByDepositIdAndBillIdAndOperationId = (
    billId: string,
    depositId: string,
    operationId: number
  ): Promise<DebtOperation> => {
    return this.ovh.request(
      'GET',
      `/me/deposit/${depositId}/paidBills/${billId}/debt/operation/${operationId}`
    );
  };

  /** Return main data about the object related to this debt operation */
  getDepositPaidBillsDebtOperationAssociatedObjectByDepositIdAndBillIdAndOperationId = (
    billId: string,
    depositId: string,
    operationId: number
  ): Promise<DebtEntryAssociatedObject> => {
    return this.ovh.request(
      'GET',
      `/me/deposit/${depositId}/paidBills/${billId}/debt/operation/${operationId}/associatedObject`
    );
  };

  /** Create an order in order to pay this order's debt */
  createDepositPaidBillsDebtPayByDepositIdAndBillId = (
    billId: string,
    depositId: string
  ): Promise<BillingOrder> => {
    return this.ovh.request('POST', `/me/deposit/${depositId}/paidBills/${billId}/debt/pay`);
  };

  /** Give access to all entries of the bill */
  getDepositPaidBillsDetailsByDepositIdAndBillId = (
    billId: string,
    depositId: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/paidBills/${billId}/details`);
  };

  /** Get this object properties */
  getDepositPaidBillsDetailsByDepositIdAndBillIdAndBillDetailId = (
    billDetailId: string,
    billId: string,
    depositId: string
  ): Promise<BillingBillDetail> => {
    return this.ovh.request(
      'GET',
      `/me/deposit/${depositId}/paidBills/${billId}/details/${billDetailId}`
    );
  };

  /** Get this object properties */
  getDepositPaidBillsPaymentByDepositIdAndBillId = (
    billId: string,
    depositId: string
  ): Promise<BillingPayment> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/paidBills/${billId}/payment`);
  };

  /** Get this object properties */
  getDepositPaymentByDepositId = (depositId: string): Promise<BillingPayment> => {
    return this.ovh.request('GET', `/me/deposit/${depositId}/payment`);
  };

  /** List of documents added in your account */
  listDocument = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/document');
  };

  /** Create new document */
  createDocument = (body: { name: string; tags?: string }): Promise<NichandleDocumentDocument> => {
    return this.ovh.request('POST', '/me/document', body);
  };

  /** Add CORS support on your container */
  addDocumentCors = (body: { origin: string }): Promise<void> => {
    return this.ovh.request('POST', '/me/document/cors', body);
  };

  /** Delete a document */
  deleteDocumentById = (id: string): Promise<void> => {
    return this.ovh.request('DELETE', `/me/document/${id}`);
  };

  /** Get this object properties */
  getDocumentById = (id: string): Promise<NichandleDocumentDocument> => {
    return this.ovh.request('GET', `/me/document/${id}`);
  };

  /** Alter this object properties */
  updateDocumentById = (id: string, body: NichandleDocumentDocument): Promise<void> => {
    return this.ovh.request('PUT', `/me/document/${id}`, body);
  };

  /** Get the fax custom domains linked to the customer account */
  getFaxCustomDomains = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/fax/customDomains');
  };

  /** Create a custom domain for your fax services */
  createFaxCustomDomains = (body: { domain: string }): Promise<TelephonyMailDomain2Service> => {
    return this.ovh.request('POST', '/me/fax/customDomains', body);
  };

  /** Delete a custom domain of your fax services */
  deleteFaxCustomDomainsById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/fax/customDomains/${id}`);
  };

  /** Get this object properties */
  getFaxCustomDomainsById = (id: number): Promise<TelephonyMailDomain2Service> => {
    return this.ovh.request('GET', `/me/fax/customDomains/${id}`);
  };

  /** Get this object properties */
  getFidelityAccount = (): Promise<BillingFidelityAccount> => {
    return this.ovh.request('GET', '/me/fidelityAccount');
  };

  /** Alter this object properties */
  updateFidelityAccount = (body: BillingFidelityAccount): Promise<void> => {
    return this.ovh.request('PUT', '/me/fidelityAccount', body);
  };

  /** Generate an order that can be paid in order to credit the fidelity account */
  postFidelityAccountCreditOrder = (body: { amount: number }): Promise<BillingOrder> => {
    return this.ovh.request('POST', '/me/fidelityAccount/creditOrder', body);
  };

  /** List of entries of the fidelity account */
  listFidelityAccountMovements = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/fidelityAccount/movements');
  };

  /** Get this object properties */
  getFidelityAccountMovementsByMovementId = (
    movementId: number
  ): Promise<BillingFidelityMovement> => {
    return this.ovh.request('GET', `/me/fidelityAccount/movements/${movementId}`);
  };

  /** Fetch visitor country & region */
  postGeolocation = (): Promise<MeGeolocationContinentCountryLocation> => {
    return this.ovh.request('POST', '/me/geolocation');
  };

  /** Retrieve all groups of this account */
  getIdentityGroup = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/identity/group');
  };

  /** Create a new group */
  createIdentityGroup = (body: {
    description?: string;
    name: string;
    role?: NichandleAuthenticationRoleEnum;
  }): Promise<NichandleAuthenticationGroup> => {
    return this.ovh.request('POST', '/me/identity/group', body);
  };

  /** Delete this object */
  deleteIdentityGroupByGroup = (group: string): Promise<void> => {
    return this.ovh.request('DELETE', `/me/identity/group/${group}`);
  };

  /** Get this object properties */
  getIdentityGroupByGroup = (group: string): Promise<NichandleAuthenticationGroup> => {
    return this.ovh.request('GET', `/me/identity/group/${group}`);
  };

  /** Alter a group */
  updateIdentityGroupByGroup = (
    group: string,
    body: { description?: string; role?: NichandleAuthenticationRoleEnum }
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/identity/group/${group}`, body);
  };

  /** Remove the identity provider */
  deleteIdentityProvider = (): Promise<void> => {
    return this.ovh.request('DELETE', '/me/identity/provider');
  };

  /** Identity provider linked to this account */
  getIdentityProvider = (): Promise<NichandleAuthenticationProvider> => {
    return this.ovh.request('GET', '/me/identity/provider');
  };

  /** Define an identity provider (SAML 2.0) */
  postIdentityProvider = (body: {
    extensions?: NichandleAuthenticationProviderExtensions;
    groupAttributeName?: string;
    metadata: string;
  }): Promise<NichandleAuthenticationProvider> => {
    return this.ovh.request('POST', '/me/identity/provider', body);
  };

  /** Alter the provider */
  updateIdentityProvider = (body: {
    extensions?: NichandleAuthenticationProviderExtensions;
    groupAttributeName?: string;
  }): Promise<void> => {
    return this.ovh.request('PUT', '/me/identity/provider', body);
  };

  /** Retrieve all users of this account */
  getIdentityUser = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/identity/user');
  };

  /** Create a new user */
  createIdentityUser = (body: {
    description?: string;
    email: string;
    group?: string;
    login: string;
    password: string;
  }): Promise<void> => {
    return this.ovh.request('POST', '/me/identity/user', body);
  };

  /** Delete this object */
  deleteIdentityUserByUser = (user: string): Promise<void> => {
    return this.ovh.request('DELETE', `/me/identity/user/${user}`);
  };

  /** Get this object properties */
  getIdentityUserByUser = (user: string): Promise<NichandleUser> => {
    return this.ovh.request('GET', `/me/identity/user/${user}`);
  };

  /** Alter a user */
  updateIdentityUserByUser = (
    user: string,
    body: { description?: string; email?: string; group?: string }
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/identity/user/${user}`, body);
  };

  /** Disable this user */
  disableIdentityUserByUser = (user: string): Promise<void> => {
    return this.ovh.request('POST', `/me/identity/user/${user}/disable`);
  };

  /** Enable this user */
  enableIdentityUserByUser = (user: string): Promise<void> => {
    return this.ovh.request('POST', `/me/identity/user/${user}/enable`);
  };

  /** Get all services you can migrate */
  getIncidentSbgMigrateServices = (): Promise<MeIncidentServiceMigration[]> => {
    return this.ovh.request('GET', '/me/incident/sbg/migrateServices');
  };

  /** Ask for impacted services migration */
  postIncidentSbgMigrateServices = (body: MeIncidentMigrateServices): Promise<MeIncidentOrder> => {
    return this.ovh.request('POST', '/me/incident/sbg/migrateServices', body);
  };

  /** Get your insight access token */
  getInsight = (): Promise<InsightAccess> => {
    return this.ovh.request('GET', '/me/insight');
  };

  /** Your customized operating system installation templates */
  getInstallationTemplate = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/installationTemplate');
  };

  /** Create a template */
  createInstallationTemplate = (body: {
    baseTemplateName: string;
    defaultLanguage: DedicatedTemplateOsLanguageEnum;
    name: string;
  }): Promise<void> => {
    return this.ovh.request('POST', '/me/installationTemplate', body);
  };

  /** Remove this template */
  deleteInstallationTemplateByTemplateName = (templateName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/me/installationTemplate/${templateName}`);
  };

  /** Get this object properties */
  getInstallationTemplateByTemplateName = (
    templateName: string
  ): Promise<DedicatedInstallationTemplateTemplates> => {
    return this.ovh.request('GET', `/me/installationTemplate/${templateName}`);
  };

  /** Alter this object properties */
  updateInstallationTemplateByTemplateName = (
    templateName: string,
    body: DedicatedInstallationTemplateTemplates
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/installationTemplate/${templateName}`, body);
  };

  /** Check the integrity of this template */
  checkInstallationTemplateIntegrityByTemplateName = (templateName: string): Promise<void> => {
    return this.ovh.request('POST', `/me/installationTemplate/${templateName}/checkIntegrity`);
  };

  /** Partitioning schemes available on this template */
  getInstallationTemplatePartitionSchemeByTemplateName = (
    templateName: string
  ): Promise<string[]> => {
    return this.ovh.request('GET', `/me/installationTemplate/${templateName}/partitionScheme`);
  };

  /** Add a scheme of partition */
  addInstallationTemplatePartitionSchemeByTemplateName = (
    templateName: string,
    body: { name: string; priority: number }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/me/installationTemplate/${templateName}/partitionScheme`,
      body
    );
  };

  /** Remove this scheme of partition */
  deleteInstallationTemplatePartitionSchemeByTemplateNameAndSchemeName = (
    schemeName: string,
    templateName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}`
    );
  };

  /** Get this object properties */
  getInstallationTemplatePartitionSchemeByTemplateNameAndSchemeName = (
    schemeName: string,
    templateName: string
  ): Promise<DedicatedInstallationTemplateTemplatePartitioningSchemes> => {
    return this.ovh.request(
      'GET',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}`
    );
  };

  /** Alter this object properties */
  updateInstallationTemplatePartitionSchemeByTemplateNameAndSchemeName = (
    schemeName: string,
    templateName: string,
    body: DedicatedInstallationTemplateTemplatePartitioningSchemes
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}`,
      body
    );
  };

  /** Hardware RAIDs defined in this partitioning scheme */
  getInstallationTemplatePartitionSchemeHardwareRaidByTemplateNameAndSchemeName = (
    schemeName: string,
    templateName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/hardwareRaid`
    );
  };

  /** Add an hardware RAID in this partitioning scheme */
  addInstallationTemplatePartitionSchemeHardwareRaidByTemplateNameAndSchemeName = (
    schemeName: string,
    templateName: string,
    body: { disks: string[]; mode: DedicatedTemplateOsHardwareRaidEnum; name: string; step: number }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/hardwareRaid`,
      body
    );
  };

  /** Remove this RAID */
  deleteInstallationTemplatePartitionSchemeHardwareRaidByTemplateNameAndSchemeNameAndName = (
    name: string,
    schemeName: string,
    templateName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/hardwareRaid/${name}`
    );
  };

  /** Get this object properties */
  getInstallationTemplatePartitionSchemeHardwareRaidByTemplateNameAndSchemeNameAndName = (
    name: string,
    schemeName: string,
    templateName: string
  ): Promise<DedicatedInstallationTemplateHardwareRaid> => {
    return this.ovh.request(
      'GET',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/hardwareRaid/${name}`
    );
  };

  /** Alter this object properties */
  updateInstallationTemplatePartitionSchemeHardwareRaidByTemplateNameAndSchemeNameAndName = (
    name: string,
    schemeName: string,
    templateName: string,
    body: DedicatedInstallationTemplateHardwareRaid
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/hardwareRaid/${name}`,
      body
    );
  };

  /** Partitions defined in this partitioning scheme */
  getInstallationTemplatePartitionSchemePartitionByTemplateNameAndSchemeName = (
    schemeName: string,
    templateName: string
  ): Promise<string[]> => {
    return this.ovh.request(
      'GET',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/partition`
    );
  };

  /** Add a partition in this partitioning scheme */
  addInstallationTemplatePartitionSchemePartitionByTemplateNameAndSchemeName = (
    schemeName: string,
    templateName: string,
    body: {
      filesystem: DedicatedTemplateOsFileSystemEnum;
      mountpoint: string;
      raid?: DedicatedServerPartitionRaidEnum;
      size: number;
      step: number;
      type: DedicatedTemplatePartitionTypeEnum;
      volumeName?: string;
    }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/partition`,
      body
    );
  };

  /** Remove this partition */
  deleteInstallationTemplatePartitionSchemePartitionByTemplateNameAndSchemeNameAndMountpoint = (
    mountpoint: string,
    schemeName: string,
    templateName: string
  ): Promise<void> => {
    return this.ovh.request(
      'DELETE',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/partition/${mountpoint}`
    );
  };

  /** Get this object properties */
  getInstallationTemplatePartitionSchemePartitionByTemplateNameAndSchemeNameAndMountpoint = (
    mountpoint: string,
    schemeName: string,
    templateName: string
  ): Promise<DedicatedInstallationTemplateTemplatePartitions> => {
    return this.ovh.request(
      'GET',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/partition/${mountpoint}`
    );
  };

  /** Alter this object properties */
  updateInstallationTemplatePartitionSchemePartitionByTemplateNameAndSchemeNameAndMountpoint = (
    mountpoint: string,
    schemeName: string,
    templateName: string,
    body: DedicatedInstallationTemplateTemplatePartitions
  ): Promise<void> => {
    return this.ovh.request(
      'PUT',
      `/me/installationTemplate/${templateName}/partitionScheme/${schemeName}/partition/${mountpoint}`,
      body
    );
  };

  /** List of organisations */
  listIpOrganisation = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/ipOrganisation');
  };

  /** Add an organisation */
  addIpOrganisation = (body: {
    abuse_mailbox: string;
    address: string;
    city: string;
    country: NichandleCountryEnum;
    firstname: string;
    lastname: string;
    phone: string;
    registry: NichandleIpRegistryEnum;
    state?: string;
    zip?: string;
  }): Promise<void> => {
    return this.ovh.request('POST', '/me/ipOrganisation', body);
  };

  /** Delete this organisation */
  deleteIpOrganisationByOrganisationId = (organisationId: string): Promise<void> => {
    return this.ovh.request('DELETE', `/me/ipOrganisation/${organisationId}`);
  };

  /** Get this object properties */
  getIpOrganisationByOrganisationId = (organisationId: string): Promise<NichandleIpv4Org> => {
    return this.ovh.request('GET', `/me/ipOrganisation/${organisationId}`);
  };

  /** Alter this object properties */
  updateIpOrganisationByOrganisationId = (
    organisationId: string,
    body: NichandleIpv4Org
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/ipOrganisation/${organisationId}`, body);
  };

  /** List of all your IPXE scripts */
  listIpxeScript = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/ipxeScript');
  };

  /** Add an IPXE script */
  addIpxeScript = (body: {
    description: string;
    name: string;
    script: string;
  }): Promise<NichandleIpxe> => {
    return this.ovh.request('POST', '/me/ipxeScript', body);
  };

  /** Remove this IPXE Script */
  deleteIpxeScriptByName = (name: string): Promise<void> => {
    return this.ovh.request('DELETE', `/me/ipxeScript/${name}`);
  };

  /** Get this object properties */
  getIpxeScriptByName = (name: string): Promise<NichandleIpxe> => {
    return this.ovh.request('GET', `/me/ipxeScript/${name}`);
  };

  /** Alter this object properties */
  updateIpxeScriptByName = (name: string, body: NichandleIpxe): Promise<void> => {
    return this.ovh.request('PUT', `/me/ipxeScript/${name}`, body);
  };

  /** Get your audit logs */
  getLogsAudit = (): Promise<AuditLog[]> => {
    return this.ovh.request('GET', '/me/logs/audit');
  };

  /** List of mailing list you can subscribe */
  listMailingAvailableLists = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/mailingList/availableLists');
  };

  /** Subscribe an email to a restricted mailing list */
  postMailingListSubscribe = (body: { email: string; mailingList: string }): Promise<void> => {
    return this.ovh.request('POST', '/me/mailingList/subscribe', body);
  };

  /** Retrieve all country migrations */
  getMigration = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/migration');
  };

  /** Retrieve information about a country migration */
  getMigrationByMigrationId = (migrationId: number): Promise<MeMigration> => {
    return this.ovh.request('GET', `/me/migration/${migrationId}`);
  };

  /** Retrieve all contracts for a billing country migration */
  getMigrationContractByMigrationId = (migrationId: number): Promise<number[]> => {
    return this.ovh.request('GET', `/me/migration/${migrationId}/contract`);
  };

  /** Retrieve detail about a contract for a billing country migration */
  getMigrationContractByMigrationIdAndContractId = (
    contractId: number,
    migrationId: number
  ): Promise<MeMigrationContract> => {
    return this.ovh.request('GET', `/me/migration/${migrationId}/contract/${contractId}`);
  };

  /** Accept contract */
  postMigrationContractAcceptByMigrationIdAndContractId = (
    contractId: number,
    migrationId: number
  ): Promise<MeAgreementsContractAgreement> => {
    return this.ovh.request('POST', `/me/migration/${migrationId}/contract/${contractId}/accept`);
  };

  /** Retrieve agreement for this contract */
  getMigrationContractAgreementByMigrationIdAndContractId = (
    contractId: number,
    migrationId: number
  ): Promise<MeAgreementsContractAgreement> => {
    return this.ovh.request('GET', `/me/migration/${migrationId}/contract/${contractId}/agreement`);
  };

  /** Retrieve every email sent to you */
  getNotificationEmailHistory = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/notification/email/history');
  };

  /** Retrieve information about an email */
  getNotificationEmailHistoryById = (id: number): Promise<NichandleEmailNotification> => {
    return this.ovh.request('GET', `/me/notification/email/history/${id}`);
  };

  /** List of all the orders the logged account has */
  listOrder = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/order');
  };

  /** Get this object properties */
  getOrderByOrderId = (orderId: number): Promise<BillingOrder> => {
    return this.ovh.request('GET', `/me/order/${orderId}`);
  };

  /** Return main data about the object the processing of the order generated */
  getOrderAssociatedObjectByOrderId = (orderId: number): Promise<BillingOrderAssociatedObject> => {
    return this.ovh.request('GET', `/me/order/${orderId}/associatedObject`);
  };

  /** List of registered payment mean you can use to pay this order */
  listOrderAvailableRegisteredPaymentMeanByOrderId = (
    orderId: number
  ): Promise<BillingOrderRegisteredPaymentMean[]> => {
    return this.ovh.request('GET', `/me/order/${orderId}/availableRegisteredPaymentMean`);
  };

  /** List credit balances applied on this Order */
  listOrderBalanceByOrderId = (orderId: number): Promise<string[]> => {
    return this.ovh.request('GET', `/me/order/${orderId}/balance`);
  };

  /** Use a credit balance on this Order */
  postOrderBalanceByOrderId = (
    orderId: number,
    body: { balanceName: string }
  ): Promise<BillingCreditBalance> => {
    return this.ovh.request('POST', `/me/order/${orderId}/balance`, body);
  };

  /** Remove a credit balance from this Order */
  deleteOrderBalanceByOrderIdAndBalanceName = (
    balanceName: string,
    orderId: number
  ): Promise<void> => {
    return this.ovh.request('DELETE', `/me/order/${orderId}/balance/${balanceName}`);
  };

  /** Get this object properties */
  getOrderBalanceByOrderIdAndBalanceName = (
    balanceName: string,
    orderId: number
  ): Promise<BillingCreditBalance> => {
    return this.ovh.request('GET', `/me/order/${orderId}/balance/${balanceName}`);
  };

  /** Retrieve order's detailed consumption information as a file */
  getOrderConsumptionDetailsByOrderId = (
    orderId: number
  ): Promise<BillingOrderConsumptionDetails> => {
    return this.ovh.request('GET', `/me/order/${orderId}/consumption/details`);
  };

  /** Get this object properties */
  getOrderDebtByOrderId = (orderId: number): Promise<DebtDebt> => {
    return this.ovh.request('GET', `/me/order/${orderId}/debt`);
  };

  /** All operations related to these debts */
  getOrderDebtOperationByOrderId = (orderId: number): Promise<number[]> => {
    return this.ovh.request('GET', `/me/order/${orderId}/debt/operation`);
  };

  /** Get this object properties */
  getOrderDebtOperationByOrderIdAndOperationId = (
    operationId: number,
    orderId: number
  ): Promise<DebtOperation> => {
    return this.ovh.request('GET', `/me/order/${orderId}/debt/operation/${operationId}`);
  };

  /** Return main data about the object related to this debt operation */
  getOrderDebtOperationAssociatedObjectByOrderIdAndOperationId = (
    operationId: number,
    orderId: number
  ): Promise<DebtEntryAssociatedObject> => {
    return this.ovh.request(
      'GET',
      `/me/order/${orderId}/debt/operation/${operationId}/associatedObject`
    );
  };

  /** Create an order in order to pay this order's debt */
  createOrderDebtPayByOrderId = (orderId: number): Promise<BillingOrder> => {
    return this.ovh.request('POST', `/me/order/${orderId}/debt/pay`);
  };

  /** Give access to all entries of the order */
  getOrderDetailsByOrderId = (orderId: number): Promise<number[]> => {
    return this.ovh.request('GET', `/me/order/${orderId}/details`);
  };

  /** Get this object properties */
  getOrderDetailsByOrderIdAndOrderDetailId = (
    orderDetailId: number,
    orderId: number
  ): Promise<BillingOrderDetail> => {
    return this.ovh.request('GET', `/me/order/${orderId}/details/${orderDetailId}`);
  };

  /** Get this object properties */
  getOrderDetailsExtensionByOrderIdAndOrderDetailId = (
    orderDetailId: number,
    orderId: number
  ): Promise<BillingItemDetail> => {
    return this.ovh.request('GET', `/me/order/${orderId}/details/${orderDetailId}/extension`);
  };

  /** Return tracking of the order */
  getOrderFollowUpByOrderId = (orderId: number): Promise<BillingOrderFollowUp[]> => {
    return this.ovh.request('GET', `/me/order/${orderId}/followUp`);
  };

  /** Pay with a payment method reference */
  postOrderPayByOrderId = (
    orderId: number,
    body: { paymentMethod: BillingOrderPayWithPaymentMethod }
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/order/${orderId}/pay`, body);
  };

  /** Pay with an already registered payment mean */
  postOrderPayWithRegisteredPaymentMeanByOrderId = (
    orderId: number,
    body: { paymentMean: BillingReusablePaymentMeanEnum; paymentMeanId?: number }
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/order/${orderId}/payWithRegisteredPaymentMean`, body);
  };

  /** Get this object properties */
  getOrderPaymentByOrderId = (orderId: number): Promise<BillingPayment> => {
    return this.ovh.request('GET', `/me/order/${orderId}/payment`);
  };

  /** Return main data about the object the processing of the order generated */
  getOrderPaymentMeansByOrderId = (orderId: number): Promise<BillingOrderPaymentMeans> => {
    return this.ovh.request('GET', `/me/order/${orderId}/paymentMeans`);
  };

  /** List of registered payment method you can use to pay this order */
  listOrderPaymentMethodsByOrderId = (orderId: number): Promise<BillingOrderPaymentMethods> => {
    return this.ovh.request('GET', `/me/order/${orderId}/paymentMethods`);
  };

  /** Request retraction of order */
  postOrderRetractionByOrderId = (
    orderId: number,
    body: { comment?: string; reason: BillingOrderRetractionReasonEnum }
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/order/${orderId}/retraction`, body);
  };

  /** Return status of order */
  getOrderStatusByOrderId = (orderId: number): Promise<BillingOrderOrderStatusEnum> => {
    return this.ovh.request('GET', `/me/order/${orderId}/status`);
  };

  /** Waive retraction period of order */
  postOrderWaiveRetractionByOrderId = (orderId: number): Promise<void> => {
    return this.ovh.request('POST', `/me/order/${orderId}/waiveRetraction`);
  };

  /** List of OVH accounts the logged account has */
  listOvhAccount = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/ovhAccount');
  };

  /** Get this object properties */
  getOvhAccountByOvhAccountId = (ovhAccountId: string): Promise<BillingOvhAccount> => {
    return this.ovh.request('GET', `/me/ovhAccount/${ovhAccountId}`);
  };

  /** Alter this object properties */
  updateOvhAccountByOvhAccountId = (
    ovhAccountId: string,
    body: BillingOvhAccount
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/ovhAccount/${ovhAccountId}`, body);
  };

  /** Generate an order that can be paid in order to credit the OVH account */
  postOvhAccountCreditOrderByOvhAccountId = (
    ovhAccountId: string,
    body: { amount: number }
  ): Promise<BillingOrder> => {
    return this.ovh.request('POST', `/me/ovhAccount/${ovhAccountId}/creditOrder`, body);
  };

  /** Details about an entry of the OVH account */
  getOvhAccountMovementsByOvhAccountId = (ovhAccountId: string): Promise<number[]> => {
    return this.ovh.request('GET', `/me/ovhAccount/${ovhAccountId}/movements`);
  };

  /** Get this object properties */
  getOvhAccountMovementsByOvhAccountIdAndMovementId = (
    movementId: number,
    ovhAccountId: string
  ): Promise<BillingMovement> => {
    return this.ovh.request('GET', `/me/ovhAccount/${ovhAccountId}/movements/${movementId}`);
  };

  /** request a refund of this credit note to your original payment method */
  postOvhAccountMovementsRequestRefundByOvhAccountIdAndMovementId = (
    movementId: number,
    ovhAccountId: string,
    body: { amount: number }
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/me/ovhAccount/${ovhAccountId}/movements/${movementId}/requestRefund`,
      body
    );
  };

  /** Transfer money from ovhAccount to your bank account */
  postOvhAccountRetrieveMoneyByOvhAccountId = (
    ovhAccountId: string,
    body: { amount: number; bankAccountId: number }
  ): Promise<BillingOrder> => {
    return this.ovh.request('POST', `/me/ovhAccount/${ovhAccountId}/retrieveMoney`, body);
  };

  /** Fetch the partner level of the account */
  getPartnerLevel = (): Promise<MePartnerLevelLevel> => {
    return this.ovh.request('GET', '/me/partnerLevel');
  };

  /** Request a password recover */
  postPasswordRecover = (body: {
    ovhCompany: NichandleOvhCompanyEnum;
    ovhId: string;
  }): Promise<void> => {
    return this.ovh.request('POST', '/me/passwordRecover', body);
  };

  /** Retrieve available payment method */
  getPaymentAvailableMethods = (): Promise<MePaymentAvailablePaymentMethod[]> => {
    return this.ovh.request('GET', '/me/payment/availableMethods');
  };

  /** Retrieve payment method list */
  getPaymentMethod = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/payment/method');
  };

  /** Register a new payment method */
  postPaymentMethod = (body: MePaymentMethodCreation): Promise<MePaymentMethodValidation> => {
    return this.ovh.request('POST', '/me/payment/method', body);
  };

  /** Delete a payment method */
  deletePaymentMethodByPaymentMethodId = (
    paymentMethodId: number
  ): Promise<MePaymentPaymentMethod> => {
    return this.ovh.request('DELETE', `/me/payment/method/${paymentMethodId}`);
  };

  /** Retrieve a payment method */
  getPaymentMethodByPaymentMethodId = (
    paymentMethodId: number
  ): Promise<MePaymentPaymentMethod> => {
    return this.ovh.request('GET', `/me/payment/method/${paymentMethodId}`);
  };

  /** Edit payment method */
  updatePaymentMethodByPaymentMethodId = (
    paymentMethodId: number,
    body: MePaymentPaymentMethod
  ): Promise<MePaymentPaymentMethod> => {
    return this.ovh.request('PUT', `/me/payment/method/${paymentMethodId}`, body);
  };

  /** Challenge your payment method */
  postPaymentMethodChallengeByPaymentMethodId = (
    paymentMethodId: number,
    body: MePaymentMethodChallenge
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/payment/method/${paymentMethodId}/challenge`, body);
  };

  /** Add details to your payment method challenge */
  addPaymentMethodDetailsByPaymentMethodId = (
    paymentMethodId: number,
    body: MePaymentMethodDetails
  ): Promise<MePaymentMethodValidation> => {
    return this.ovh.request('POST', `/me/payment/method/${paymentMethodId}/details`, body);
  };

  /** Finalize a payment method registration */
  postPaymentMethodFinalizeByPaymentMethodId = (
    paymentMethodId: number,
    body: MePaymentMethodFinalize
  ): Promise<MePaymentPaymentMethod> => {
    return this.ovh.request('POST', `/me/payment/method/${paymentMethodId}/finalize`, body);
  };

  /** Retrieve payment transaction list */
  getPaymentTransaction = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/payment/transaction');
  };

  /** Retrieve a transaction */
  getPaymentTransactionByTransactionId = (transactionId: number): Promise<MePaymentTransaction> => {
    return this.ovh.request('GET', `/me/payment/transaction/${transactionId}`);
  };

  /** List of bank accounts */
  listPaymentMeanBankAccount = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/paymentMean/bankAccount');
  };

  /** Add a new payment mean bank account */
  addPaymentMeanBankAccount = (
    body: MePaymentMeanBankAccountCreation
  ): Promise<MePaymentMeanBankAccountValidation> => {
    return this.ovh.request('POST', '/me/paymentMean/bankAccount', body);
  };

  /** Disable payment through this account */
  disablePaymentMeanBankAccountById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/paymentMean/bankAccount/${id}`);
  };

  /** Get bank account properties */
  getPaymentMeanBankAccountById = (id: number): Promise<MePaymentMeanBankAccount> => {
    return this.ovh.request('GET', `/me/paymentMean/bankAccount/${id}`);
  };

  /** Alter this object properties */
  updatePaymentMeanBankAccountById = (
    id: number,
    body: MePaymentMeanBankAccount
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/paymentMean/bankAccount/${id}`, body);
  };

  /** Challenge your bank account */
  postPaymentMeanBankAccountChallengeById = (
    id: number,
    body: MePaymentMeanBankAccountChallengeCreation
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/paymentMean/bankAccount/${id}/challenge`, body);
  };

  /** Choose this bank account as your default payment mean. Will cancel the previous choice. */
  postPaymentMeanBankAccountChooseAsDefaultPaymentMeanById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/me/paymentMean/bankAccount/${id}/chooseAsDefaultPaymentMean`);
  };

  /** List of payment mean credit cards */
  listPaymentMeanCreditCard = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/paymentMean/creditCard');
  };

  /** Add a new payment mean credit card */
  addPaymentMeanCreditCard = (
    body: MePaymentMeanCreditCardCreation
  ): Promise<MePaymentMeanCreditCardValidation> => {
    return this.ovh.request('POST', '/me/paymentMean/creditCard', body);
  };

  /** Disable payment through this credit card */
  disablePaymentMeanCreditCardById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/paymentMean/creditCard/${id}`);
  };

  /** Get credit card properties */
  getPaymentMeanCreditCardById = (id: number): Promise<MePaymentMeanCreditCard> => {
    return this.ovh.request('GET', `/me/paymentMean/creditCard/${id}`);
  };

  /** Alter this object properties */
  updatePaymentMeanCreditCardById = (id: number, body: MePaymentMeanCreditCard): Promise<void> => {
    return this.ovh.request('PUT', `/me/paymentMean/creditCard/${id}`, body);
  };

  /** Challenge your credit card */
  postPaymentMeanCreditCardChallengeById = (
    id: number,
    body: MePaymentMeanCreditCardChallengeCreation
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/paymentMean/creditCard/${id}/challenge`, body);
  };

  /** Choose this credit card as your default payment mean. Will cancel the previous choice. */
  postPaymentMeanCreditCardChooseAsDefaultPaymentMeanById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/me/paymentMean/creditCard/${id}/chooseAsDefaultPaymentMean`);
  };

  /** List of payment mean deferred accounts */
  listPaymentMeanDeferredPaymentAccount = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/paymentMean/deferredPaymentAccount');
  };

  /** Get this object properties */
  getPaymentMeanDeferredPaymentAccountById = (id: number): Promise<MePaymentMeanDeferred> => {
    return this.ovh.request('GET', `/me/paymentMean/deferredPaymentAccount/${id}`);
  };

  /** Alter this object properties */
  updatePaymentMeanDeferredPaymentAccountById = (
    id: number,
    body: MePaymentMeanDeferred
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/paymentMean/deferredPaymentAccount/${id}`, body);
  };

  /** Choose this deferred account as your default payment mean. Will cancel the previous choice. */
  postPaymentMeanDeferredPaymentAccountChooseAsDefaultPaymentMeanById = (
    id: number
  ): Promise<void> => {
    return this.ovh.request(
      'POST',
      `/me/paymentMean/deferredPaymentAccount/${id}/chooseAsDefaultPaymentMean`
    );
  };

  /** List of payment mean paypals */
  listPaymentMeanPaypal = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/paymentMean/paypal');
  };

  /** Add a new payment mean paypal */
  addPaymentMeanPaypal = (
    body: MePaymentMeanPaypalCreation
  ): Promise<MePaymentMeanPaypalValidation> => {
    return this.ovh.request('POST', '/me/paymentMean/paypal', body);
  };

  /** Disable payment through this paypal */
  disablePaymentMeanPaypalById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/paymentMean/paypal/${id}`);
  };

  /** Get paypal properties */
  getPaymentMeanPaypalById = (id: number): Promise<MePaymentMeanPaypal> => {
    return this.ovh.request('GET', `/me/paymentMean/paypal/${id}`);
  };

  /** Alter this object properties */
  updatePaymentMeanPaypalById = (id: number, body: MePaymentMeanPaypal): Promise<void> => {
    return this.ovh.request('PUT', `/me/paymentMean/paypal/${id}`, body);
  };

  /** Challenge your paypal */
  postPaymentMeanPaypalChallengeById = (
    id: number,
    body: MePaymentMeanPaypalChallengeCreation
  ): Promise<void> => {
    return this.ovh.request('POST', `/me/paymentMean/paypal/${id}/challenge`, body);
  };

  /** Choose this paypal as your default payment mean. Will cancel the previous choice. */
  postPaymentMeanPaypalChooseAsDefaultPaymentMeanById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/me/paymentMean/paypal/${id}/chooseAsDefaultPaymentMean`);
  };

  /** Get this object properties */
  getRecommendations = (): Promise<RecommendationsRecommendations> => {
    return this.ovh.request('GET', '/me/recommendations');
  };

  /** List of all the refunds the logged account has */
  listRefund = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/refund');
  };

  /** Exports a bundle of refunds */
  exportRefund = (body: {
    archiveType: BillingArchiveTypeEnum;
    endDate?: Date;
    ids?: string[];
    startDate?: Date;
  }): Promise<void> => {
    return this.ovh.request('POST', '/me/refund/export', body);
  };

  /** Get this object properties */
  getRefundByRefundId = (refundId: string): Promise<BillingRefund> => {
    return this.ovh.request('GET', `/me/refund/${refundId}`);
  };

  /** Give access to all entries of the refund */
  getRefundDetailsByRefundId = (refundId: string): Promise<string[]> => {
    return this.ovh.request('GET', `/me/refund/${refundId}/details`);
  };

  /** Get this object properties */
  getRefundDetailsByRefundIdAndRefundDetailId = (
    refundDetailId: string,
    refundId: string
  ): Promise<BillingRefundDetail> => {
    return this.ovh.request('GET', `/me/refund/${refundId}/details/${refundDetailId}`);
  };

  /** Get this object properties */
  getRefundPaymentByRefundId = (refundId: string): Promise<BillingPayment> => {
    return this.ovh.request('GET', `/me/refund/${refundId}/payment`);
  };

  /** List all the bills sent by the current account */
  listReverseBill = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/reverseBill');
  };

  /** Get this object properties */
  getReverseBillByReverseBillId = (reverseBillId: string): Promise<BillingReverseBill> => {
    return this.ovh.request('GET', `/me/reverseBill/${reverseBillId}`);
  };

  /** Give access to all entries of this withdrawal */
  getReverseBillDetailsByReverseBillId = (reverseBillId: string): Promise<string[]> => {
    return this.ovh.request('GET', `/me/reverseBill/${reverseBillId}/details`);
  };

  /** Get this object properties */
  getReverseBillDetailsByReverseBillIdAndReverseBillDetailId = (
    reverseBillDetailId: string,
    reverseBillId: string
  ): Promise<BillingReversableBillDetail> => {
    return this.ovh.request(
      'GET',
      `/me/reverseBill/${reverseBillId}/details/${reverseBillDetailId}`
    );
  };

  /** Get this object properties */
  getReverseBillPaymentByReverseBillId = (reverseBillId: string): Promise<BillingPayment> => {
    return this.ovh.request('GET', `/me/reverseBill/${reverseBillId}/payment`);
  };

  /** List active SLA */
  listSla = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/sla');
  };

  /** Get this object properties */
  getSlaById = (id: number): Promise<BillingSlaOperation> => {
    return this.ovh.request('GET', `/me/sla/${id}`);
  };

  /** Ask for SLA application */
  postSlaApplyById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/me/sla/${id}/apply`);
  };

  /** Check whether this SLA can be applied on your services */
  checkSlaCanBeAppliedById = (id: number): Promise<boolean> => {
    return this.ovh.request('GET', `/me/sla/${id}/canBeApplied`);
  };

  /** Get services impacted by this SLA */
  getSlaServicesById = (id: number): Promise<BillingSlaOperationService[]> => {
    return this.ovh.request('GET', `/me/sla/${id}/services`);
  };

  /** Get the status request of this SLA */
  getSlaStatusById = (id: number): Promise<string> => {
    return this.ovh.request('GET', `/me/sla/${id}/status`);
  };

  /** List of your public SSH keys */
  listSshKey = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/sshKey');
  };

  /** Add a new public SSH key */
  addSshKey = (body: { key: string; keyName: string }): Promise<void> => {
    return this.ovh.request('POST', '/me/sshKey', body);
  };

  /** Remove this public SSH key */
  deleteSshKeyByKeyName = (keyName: string): Promise<void> => {
    return this.ovh.request('DELETE', `/me/sshKey/${keyName}`);
  };

  /** Get this object properties */
  getSshKeyByKeyName = (keyName: string): Promise<NichandleSshKey> => {
    return this.ovh.request('GET', `/me/sshKey/${keyName}`);
  };

  /** Alter this object properties */
  updateSshKeyByKeyName = (keyName: string, body: NichandleSshKey): Promise<void> => {
    return this.ovh.request('PUT', `/me/sshKey/${keyName}`, body);
  };

  /** List of sub-accounts */
  listSubAccount = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/subAccount');
  };

  /** Create a new sub-account */
  createSubAccount = (body: { description?: string }): Promise<number> => {
    return this.ovh.request('POST', '/me/subAccount', body);
  };

  /** Get this object properties */
  getSubAccountById = (id: number): Promise<NichandleSubAccount> => {
    return this.ovh.request('GET', `/me/subAccount/${id}`);
  };

  /** Alter this object properties */
  updateSubAccountById = (id: number, body: NichandleSubAccount): Promise<void> => {
    return this.ovh.request('PUT', `/me/subAccount/${id}`, body);
  };

  /** Create a consumer key for the current application */
  createSubAccountConsumerKeyById = (id: number): Promise<NichandleSubAccountConsumerKey> => {
    return this.ovh.request('POST', `/me/subAccount/${id}/createConsumerKey`);
  };

  /** List of all OVH things you can subscribe to */
  listSubscription = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/subscription');
  };

  /** Get this object properties */
  getSubscriptionBySubscriptionType = (
    subscriptionType: string
  ): Promise<NichandleSubscription> => {
    return this.ovh.request('GET', `/me/subscription/${subscriptionType}`);
  };

  /** Alter this object properties */
  updateSubscriptionBySubscriptionType = (
    subscriptionType: string,
    body: NichandleSubscription
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/subscription/${subscriptionType}`, body);
  };

  /** Fetch the support level of the account */
  getSupportLevel = (): Promise<MeSupportLevelLevel> => {
    return this.ovh.request('GET', '/me/supportLevel');
  };

  /** Retrieve customer tags list */
  getTag = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/tag');
  };

  /** Activate customer tag */
  postTag = (body: MeTagCreation): Promise<MeTagTag> => {
    return this.ovh.request('POST', '/me/tag', body);
  };

  /** Retrieve all available tags */
  getTagAvailable = (): Promise<MeTagAvailableTag[]> => {
    return this.ovh.request('GET', '/me/tag/available');
  };

  /** Delete a customer tag */
  deleteTagByTag = (tag: string): Promise<MeTagTag> => {
    return this.ovh.request('DELETE', `/me/tag/${tag}`);
  };

  /** Retrieve a customer tag */
  getTagByTag = (tag: string): Promise<MeTagTag> => {
    return this.ovh.request('GET', `/me/tag/${tag}`);
  };

  /** List of service contact change tasks you are involved in */
  listTaskContactChange = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/task/contactChange');
  };

  /** Get this object properties */
  getTaskContactChangeById = (id: number): Promise<NichandleContactChangeTask> => {
    return this.ovh.request('GET', `/me/task/contactChange/${id}`);
  };

  /** Accept this change request */
  postTaskContactChangeAcceptById = (id: number, body: { token: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/task/contactChange/${id}/accept`, body);
  };

  /** Refuse this change request */
  postTaskContactChangeRefuseById = (id: number, body: { token: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/task/contactChange/${id}/refuse`, body);
  };

  /** This call will send you a new email, containing a new token */
  postTaskContactChangeResendEmailById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/me/task/contactChange/${id}/resendEmail`);
  };

  /** List of domain tasks */
  listTaskDomain = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/task/domain');
  };

  /** Get this object properties */
  getTaskDomainById = (id: number): Promise<DomainTask> => {
    return this.ovh.request('GET', `/me/task/domain/${id}`);
  };

  /** Accelerate the task */
  postTaskDomainAccelerateById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/me/task/domain/${id}/accelerate`);
  };

  /** List of arguments */
  listTaskDomainArgumentById = (id: number): Promise<string[]> => {
    return this.ovh.request('GET', `/me/task/domain/${id}/argument`);
  };

  /** Get this object properties */
  getTaskDomainArgumentByIdAndKey = (
    id: number,
    key: string
  ): Promise<NichandleDomainTaskArgument> => {
    return this.ovh.request('GET', `/me/task/domain/${id}/argument/${key}`);
  };

  /** Alter this object properties */
  updateTaskDomainArgumentByIdAndKey = (
    id: number,
    key: string,
    body: NichandleDomainTaskArgument
  ): Promise<void> => {
    return this.ovh.request('PUT', `/me/task/domain/${id}/argument/${key}`, body);
  };

  /** Cancel the task */
  postTaskDomainCancelById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/me/task/domain/${id}/cancel`);
  };

  /** Show progress of a task */
  getTaskDomainProgressbarById = (id: number): Promise<NichandleDomainTaskProgressBar> => {
    return this.ovh.request('GET', `/me/task/domain/${id}/progressbar`);
  };

  /** Relaunch the task */
  postTaskDomainRelaunchById = (id: number): Promise<void> => {
    return this.ovh.request('POST', `/me/task/domain/${id}/relaunch`);
  };

  /** List of email change tasks you are involved in */
  listTaskEmailChange = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/task/emailChange');
  };

  /** Get this object properties */
  getTaskEmailChangeById = (id: number): Promise<NichandleEmailChangeTask> => {
    return this.ovh.request('GET', `/me/task/emailChange/${id}`);
  };

  /** Accept this change request */
  postTaskEmailChangeAcceptById = (id: number, body: { token: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/task/emailChange/${id}/accept`, body);
  };

  /** Refuse this change request */
  postTaskEmailChangeRefuseById = (id: number, body: { token: string }): Promise<void> => {
    return this.ovh.request('POST', `/me/task/emailChange/${id}/refuse`, body);
  };

  /** The default SIP IP restictions for your future VoIP lines */
  getTelephonyDefaultIpRestriction = (): Promise<number[]> => {
    return this.ovh.request('GET', '/me/telephony/defaultIpRestriction');
  };

  /** Create a default IP restriction for your future VoIP lines */
  createTelephonyDefaultIpRestriction = (body: {
    subnet: string;
    type: TelephonyProtocolEnum;
  }): Promise<TelephonyDefaultIpRestriction> => {
    return this.ovh.request('POST', '/me/telephony/defaultIpRestriction', body);
  };

  /** Delete a default IP restriction for your future VoIP lines */
  deleteTelephonyDefaultIpRestrictionById = (id: number): Promise<void> => {
    return this.ovh.request('DELETE', `/me/telephony/defaultIpRestriction/${id}`);
  };

  /** Get this object properties */
  getTelephonyDefaultIpRestrictionById = (id: number): Promise<TelephonyDefaultIpRestriction> => {
    return this.ovh.request('GET', `/me/telephony/defaultIpRestriction/${id}`);
  };

  /** Get the telephony settings linked to the customer account */
  getTelephonySettings = (): Promise<TelephonySettings> => {
    return this.ovh.request('GET', '/me/telephony/settings');
  };

  /** Change the telephony settings linked to the customer account */
  updateTelephonySettings = (body: { settings: TelephonySettings }): Promise<void> => {
    return this.ovh.request('POST', '/me/telephony/settings', body);
  };

  /** VIP Status of this account */
  getVipStatus = (): Promise<NichandleVipStatus> => {
    return this.ovh.request('GET', '/me/vipStatus');
  };

  /** Verify existing voucher */
  postVoucherCheckValidity = (body: { voucher: string }): Promise<NichandleVoucherStatus> => {
    return this.ovh.request('POST', '/me/voucher/checkValidity', body);
  };

  /** List of all the withdrawals made from your prepaid account */
  listWithdrawal = (): Promise<string[]> => {
    return this.ovh.request('GET', '/me/withdrawal');
  };

  /** Get this object properties */
  getWithdrawalByWithdrawalId = (withdrawalId: string): Promise<BillingWithdrawal> => {
    return this.ovh.request('GET', `/me/withdrawal/${withdrawalId}`);
  };

  /** Give access to all entries of this withdrawal */
  getWithdrawalDetailsByWithdrawalId = (withdrawalId: string): Promise<string[]> => {
    return this.ovh.request('GET', `/me/withdrawal/${withdrawalId}/details`);
  };

  /** Get this object properties */
  getWithdrawalDetailsByWithdrawalIdAndWithdrawalDetailId = (
    withdrawalDetailId: string,
    withdrawalId: string
  ): Promise<BillingWithdrawalDetail> => {
    return this.ovh.request('GET', `/me/withdrawal/${withdrawalId}/details/${withdrawalDetailId}`);
  };

  /** Get this object properties */
  getWithdrawalPaymentByWithdrawalId = (withdrawalId: string): Promise<BillingPayment> => {
    return this.ovh.request('GET', `/me/withdrawal/${withdrawalId}/payment`);
  };

  /** Get xdsl settings linked to the nichandle */
  getXdslSetting = (): Promise<XdslSetting> => {
    return this.ovh.request('GET', '/me/xdsl/setting');
  };

  /** Change xdsl settings linked to the nichandle */
  updateXdslSetting = (body: {
    resellerFastModemShipping?: boolean;
    resellerModemBasicConfig?: boolean;
  }): Promise<void> => {
    return this.ovh.request('POST', '/me/xdsl/setting', body);
  };
}

export { MeHandler };
